<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    cancel-btn="Отменить"
    success-btn="Изменить"
    @submit="close(true)"
    @closed="$emit('closed')"
  >
    <template #header>
      Принадлежность к АТЕ
    </template>

    <BAteTreeForm
      :regions.sync="regions"
      :municipalities.sync="municipalities"
      :schools.sync="schools"
      :model="model"
      :searchless="searchless"
      :max-level="maxLevel"
      :parent_mode="parent_mode"
      max-height="480px"
      autofocus
    />
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BAteTreeForm from '@/components/forms/BAteTree/BAteTreeForm.vue'

export default {
  name: 'BTextFieldAteModal',
  components: {
    BModalConfirm,
    BAteTreeForm,
  },
  inheritAttrs: false,
  props: {
    model: String,
    searchless: Boolean,
    region: {
      type: Object,
    },
    municipality: {
      type: Object,
    },
    school: {
      type: Object,
    },
    maxLevel: {
      type: Number,
      default: 3,
    },
    parent_mode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      regions: this.region ? [this.region] : [],
      municipalities: this.municipality ? [this.municipality] : [],
      schools: this.school ? [this.school] : [],
    }
  },
  methods: {
    open() {
      const promise = this.$refs.modal.open()
      return promise.then(this.closeHanlder)
    },
    close(flag) {
      return this.$refs.modal.close(flag)
    },
    closeHanlder(flag) {
      if (!flag) {
        return [
          this.region,
          this.municipality,
          this.school,
        ]
      }

      return [
        this.regions[0],
        this.municipalities[0],
        this.schools[0],
      ]
    },
  },
}
</script>
